import React from "react";
import {
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

const InputStyle = {
  marginBottom: 1,
};

const ErrorStyle = {
  marginBottom: 1,
  color: "#d32f2f",
};

// #9/#10 — a Formik-friendly MULTI-select: each option has a checkbox in the
// dropdown, and the closed field shows the selected option names (comma-joined),
// so it's obviously multi-select (vs. the plain single-select SelectInput). The
// menu stays open while picking; click away or press Escape to close. The value
// is an array of option ids.
const MultiSelectInput = ({ field, form, options, placeholder, ...props }) => {
  const selected = Array.isArray(field.value) ? field.value : [];
  const labelId = `${field.name}-multi-label`;
  return (
    <Box sx={InputStyle}>
      <FormControl fullWidth>
        <InputLabel id={labelId}>{props.label}</InputLabel>
        <Select
          labelId={labelId}
          multiple
          data-testid={`select-${props.label}`}
          error={
            form.errors[field.name] && form.touched[field.name] ? true : false
          }
          {...field}
          value={selected}
          {...props}
          renderValue={(vals) =>
            options
              .filter((o) => vals.includes(o.id))
              .map((o) => o.name)
              .join(", ")
          }
        >
          {options.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              <Checkbox checked={selected.indexOf(option.id) > -1} />
              <ListItemText primary={option.name} />
            </MenuItem>
          ))}
        </Select>
        {form.errors[field.name] && form.touched[field.name] && (
          <Typography sx={ErrorStyle} variant="body2">
            {form.errors[field.name]}
          </Typography>
        )}
      </FormControl>
    </Box>
  );
};

export default MultiSelectInput;
